// extracted by mini-css-extract-plugin
module.exports = {"facetMenu":"OC","fixed":"PC","nonLayerdFacets":"QC","productCount":"RC","facetBack":"SC","arrow":"TC"};